import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LOGO_IMAGE from '../../images/Quartz Cloud Logo.svg';

const LogoSvg = ({ href, className }) => {
	return href ? (
		<Link to={href} className={className} title="Go to home">
          <img src={LOGO_IMAGE} className={className || 'brand-logo'}  alt="Quartz logo" />
		</Link>
	) : (
    <img src={LOGO_IMAGE} className={className} alt="Quartz logo" />
	);
};

LogoSvg.propTypes = {
	href: PropTypes.string,
	strokeColor: PropTypes.string,
	strokeWidth: PropTypes.string
};

export default LogoSvg;
